import { Column, Row } from 'hedron';
import React from 'react';
import PropTypes from 'prop-types';
import DesignerListSectionSubcolumn from './DesignerListSectionSubcolumn';
import LetterColumn from './styled/LetterColumn';
import Letter from './styled/Letter';
import EmptySectionMessage from './styled/EmptySectionMessage';

const DesignerListEmptySection = ({ letter }) => (
  <Row alignContent="center" alignItems="center" alignSelf="center" style={{ width: '100%' }} divisions={15}>
    <DesignerListSectionSubcolumn index={0}>
      <LetterColumn>
        <Letter>{letter}</Letter>
      </LetterColumn>
    </DesignerListSectionSubcolumn>
    <Column key={1} lg={12} divisions={15} fluid>
      <EmptySectionMessage>NO DESIGNERS</EmptySectionMessage>
    </Column>
  </Row>
);

DesignerListEmptySection.propTypes = {
  letter: PropTypes.string.isRequired,
};

export default DesignerListEmptySection;
